import { modalMapper } from ".";
import { Suspense } from "react";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { modalActions, MODAL } from "redux/slices/modal";
import CircleLoader from "components/atoms/CircleLoader";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { useTranslation } from "react-i18next";

function AppModal() {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const type = useAppSelector((state) => state.modal.type);
  const open = useAppSelector((state) => state.modal.open);
  const width = useAppSelector((state) => state.modal.width);
  const loading = useAppSelector((state) => state.modal.loading);
  const isBookingTypeChooser = type === MODAL.BOOKING_TYPE_CHOOSER;

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (isBookingTypeChooser) return;
        if (reason !== "backdropClick") dispatch(modalActions.closeModal());
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: isBookingTypeChooser ? 2147483646 : undefined,
      }}
    >
      <Box
        className="app-modal-body"
        sx={{
          p: 3,
          width: "100%",
          border: "none",
          maxWidth: width,
          maxHeight: "90vh",
          //   overflowY: "auto",
          borderRadius: "16px",
          bgcolor: "background.paper",
          ":focus-visible": {
            outline: "none",
          },
        }}
      >
        <ErrorBoundary>
          <div style={{ minHeight: "123px", position: "relative" }}>
            {!isBookingTypeChooser && (
              <CloseIcon
                style={{
                  position: "absolute",
                  top: 0,
                  zIndex: 9,
                  left: i18n?.language === "ar" ? "10" : "none",
                  right: i18n?.language === "ar" ? "none" : "10",
                  cursor: "pointer",
                }}
                onClick={() => dispatch(modalActions.closeModal())}
              />
            )}
            {loading && <CircleLoader />}

            <Suspense fallback={<CircleLoader />}>
              {type && modalMapper[type]}
            </Suspense>
          </div>
        </ErrorBoundary>
      </Box>
    </Modal>
  );
}

export default AppModal;
